import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Box,
  Divider,
  Typography,
} from '@material-ui/core';
import { connect } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import themeStyles from './TicketInfo.styles';
import MessageFormWrapper from './MessageForm/MessageFormWrapper';
import Messages from './Messages/Messages';
import SmallPreloader from '../../common/SmallPreloader/SmallPreloader';
import { getTicketInfo, resetTicketInfo } from '../../../../store/ticketInfoReducer';

const useStyles = makeStyles((theme) => themeStyles(theme));

const locationList = {
  'MARIE_CURIE': 'Marie Curie',
  'FREDERICK_BANTIN': 'Frederick Bantin',
  'ARMAND_FRAPPIER': 'Armand – Frappier',
  'LEVY': 'Levy',
};

const TicketInfo = ({ ticketId, getTicketInfo, resetTicketInfo, open, onClose, user, ticket, search, ticketUser }) => {
  const classes = useStyles();
  const [msgFormReady, setMsgFormReady] = useState(false);

  const handleClose = () => {
    resetTicketInfo();
    onClose();
  };
  const handleFormInit = (status) => {
    setMsgFormReady(status);
  };

  useEffect(() => {
    if (open && !search) getTicketInfo(user.userId, ticketId, user.role);
  }, [getTicketInfo, ticketId, user, open, search]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      classes={{
        scrollPaper: classes.scrollPaper,
        paper: classes.paper,
      }}
    >
      <DialogTitle>
        <Grid container justify="space-between" alignItems="flex-start">
          <Box className={classes.subjectWrap}>
            <Typography variant="subtitle1" color="primary">Subject</Typography>
            <Typography variant="h6" className={classes.subject}>{ticket.subject}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" color="primary">Ticket Number</Typography>
            <Typography variant="h6" className={classes.subject}>{ticket.id}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" color="primary">Location</Typography>
            <Typography variant="h4" className={classes.subject}>{locationList[ticket.location] || 'N/A'}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle1" color="primary">Room No.</Typography>
            <Typography variant="h4" className={classes.subject}>{ticket.roomNumber || 'N/A'}</Typography>
          </Box>
          <IconButton aria-label="close" size="small" onClick={handleClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        {!msgFormReady && <SmallPreloader />}
        <Box style={{ visibility: msgFormReady ? 'visible' : 'hidden' }}>
          <MessageFormWrapper onFormInit={handleFormInit} ticket={ticket} />
        </Box>
        { ticketUser.mobileNumber
          && (
          <>
            <Divider />
            <Box m="0.5rem 0 0.5rem">
              <Typography variant="subtitle1" color="primary">User Details</Typography>
              <Typography variant="body2" color="textSecondary">
                Mobile Number
                {' '}
                {ticketUser.mobileNumber}
              </Typography>
            </Box>
          </>
          )}
        {msgFormReady && <Messages />}
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  ticket: state.ticketInfo,
  user: state.auth,
  ticketUser: state.ticketInfo.userDetails,
});

export default connect(mapStateToProps, {
  getTicketInfo,
  resetTicketInfo,
})(TicketInfo);
